import {
  AI_AUTOPILOT_USER_ID,
  AUTO_REPLY_USER_ID,
  CHATBOT_USER_ID,
} from "@redotech/ai-autopilot-constants/constant";

export const REDO_API_URL = process.env.REDO_API_URL || "http://localhost:8888";
export const REDO_SHOPIFY_SERVER_URL =
  process.env.REDO_SHOPIFY_SERVER_URL || "http://localhost:8004";

export const AUTOMATED_USER_IDS = [
  CHATBOT_USER_ID,
  AI_AUTOPILOT_USER_ID,
  AUTO_REPLY_USER_ID,
];

export const CONCIERGE_CONVERSATION_LOCAL_STORAGE_HOURS = 24;
export const ANONYMOUS_CONCIERGE_CONVERSATIONS_LOCAL_STORAGE_KEY =
  "redo.anonymous-concierge-conversation-ids";
